module.exports = __webpack_public_path__ + "img/GHS01.76767dad.gif";